// src/app/core/guards/authentication.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../store/auth.store';

export const authenticationGuard: CanActivateFn = () => {
  console.log('[AuthGuard] Checking authentication...');
  const auth = inject(AuthStore);
  const router = inject(Router);

  const isAuth = auth.isAuthenticated();
  console.log('[AuthGuard] isAuthenticated:', isAuth);

  if (isAuth) {
    console.log('[AuthGuard] User is authenticated, allowing access');
    return true;
  }

  console.log('[AuthGuard] User is NOT authenticated, redirecting to login');
  return router.createUrlTree(['/login']);
};
